<template>
  <a-dropdown
    :trigger="['click']"
  >
    <div
      class="language-selector"
      :wj-eid="config.name || $t('k_471da1da')"
    >
      <Icon
        v-if="config.icon"
        :icon="config.icon"
        class="language-icon"
      />
      <a-icon
        v-else
        type="global"
        class="language-icon"
      />
      <span
        v-if="config.name"
        class="title"
      >{{ config.name }}</span>
    </div>
    <a-menu
      slot="overlay"
      :selected-keys="[currentLanguage]"
      @click="handleLanguageChange"
    >
      <a-menu-item
        v-for="lang in languages"
        :key="lang.value"
      >
        <span>{{ lang.label }}</span>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import { $t } from '@/i18n';
import Cookies from 'js-cookie';
import Icon from '@components/icon/Icon.vue';
import { LANG_NATIVE_LABELS } from '@/constants/languages';

// 语言常量
const LANG_ZH_CN = 'zh-CN';
const LANG_EN_US = 'en-US';

export default {
  name: 'NavLanguageSelect',
  components: {
    Icon,
  },
  props: {
    mode: {
      type: String,
      default: 'runtime',
    },
    config: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      languages: [],
    };
  },
  computed: {
    currentLanguage() {
      return window.langController.getLang();
    },
  },
  async mounted() {
    await this.fetchLanguages();
  },
  methods: {
    async fetchLanguages() {
      try {
        const { langs } = window.xy_runtime_i18n_data;
        if (langs && langs.length > 0) {
          this.languages = langs.map(lang => ({
            label: LANG_NATIVE_LABELS[lang] || lang.toUpperCase(),
            value: lang,
          }));
          // i18n ignore next line
          this.languages.unshift({ label: '简体中文', value: LANG_ZH_CN, icon: 'flag' });
        } else {
          this.setDefaultLanguages();
        }
      } catch (error) {
        console.error($t('k_a6caebd4'), error);
        this.setDefaultLanguages();
      }
    },
    setDefaultLanguages() {
      // 默认语言列表
      this.languages = [
        // i18n ignore next line
        { label: '简体中文', value: LANG_ZH_CN, icon: 'flag' },
        { label: 'English', value: LANG_EN_US, icon: 'flag' },
      ];
    },
    handleLanguageChange({ key }) {
      if (this.disabled) return;

      // 通过后台修改语言
      Cookies.set('wuji-set-lang', key, { expires: 1 });

      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.language-selector {
  display: inline-flex;
  align-items: center;
  font-size: var(--xy-custom-nav-font-size);
  color: var(--xy-custom-nav-color);
  margin-left: var(--xy-custom-nav-multi-menu-title-gap);
  cursor: pointer;

  &:hover {
    color: var(--xy-custom-nav-hover-color);
  }

  .language-icon {
    --xy-custom-nav-link-icon-size: unset;
    height: unset;
    max-height: unset;
    line-height: 64px;
    display: flex;
    align-items: center;
  }

  .title {
    margin-left: 4px;
  }
}
</style>
